export default __webpack_public_path__ + "static/media/151-real-estate-3.4939dc57.png";